import RulesTemplate from './rules.html';

export default angular
  .module('main.devices.edit.tabs.rules', [])

  .directive('editDeviceRulesTab', () => {
    return {
      restrict: 'E',
      template: RulesTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $state,
                   utils,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {
          viewRule: viewRule,
          deleteRule: deleteRule,
          addDefaultRules: addDefaultRules
        });

        init();

        function init() {
          $scope.loading = true;
          return $q.all([
            $scope.dataProvider.deviceRulesResource.init(),
            $scope.dataProvider.deviceIdResource.init(),
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceLocationIdResource.init(),
            $scope.dataProvider.userIdResource.init()
          ])
            .then(() => {
              $scope.loading = false;
              initViewModel();
              initWatchers();
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          // Watch changes of device goal id or list of device rules
          $scope.$watch('dataProvider.deviceResource.value.goalId', () => {
            if ($scope.deviceGoalId !== $scope.dataProvider.deviceResource.value?.goalId && $scope.dataProvider.deviceRulesResource.value) {
              initViewModel();
            }
          });
          $scope.$watch('dataProvider.deviceRulesResource.value', () => {
            if ($scope.dataProvider.deviceRulesResource.value) {
              initViewModel();
            }
          });
        }

        function initViewModel() {
          $scope.rules = angular.copy($scope.dataProvider.deviceRulesResource.value);
          $scope.deviceGoalId = $scope.dataProvider.deviceResource.value.goalId;
          $scope.userId = $scope.dataProvider.userIdResource.value;

          $scope.scenarioRules = [];
          $scope.defaultRules = [];
          $scope.userRules = [];

          $scope.rules.forEach(rule => {
            if (rule.goalId != null && $scope.deviceGoalId != null && rule.goalId === $scope.deviceGoalId) {
              $scope.scenarioRules.push(rule);
            } else if (rule.default === true) {
              $scope.defaultRules.push(rule);
            } else {
              $scope.userRules.push(rule);
            }
          });
        }

        /**
         * Goto View Rule page
         * @param rule
         */
        function viewRule(rule) {
          if (!rule || !rule.id || $scope.loading) {
            return;
          }
          utils.setStorageItem('view-rule', rule);
          $state.go('main.rules.view', {
            from: 'device',
            deviceId: $scope.dataProvider.deviceIdResource.value,
            locationId: $scope.dataProvider.deviceLocationIdResource.value,
            ruleId: rule.id
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'rules');
        }

        /**
         * Delete device rule
         * @param rule
         */
        function deleteRule(rule) {
          if ($scope.loading || !rule || !rule.id) {
            return;
          }
          $scope.loading = true;
          $scope.dataProvider.deleteDeviceRule(rule.id)
            .then(() => {
              $scope.loading = false;
              initViewModel();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        /**
         * Add default device rules
         */
        function addDefaultRules() {
          if ($scope.loading) {
            return;
          }
          $scope.loading = true;
          $scope.dataProvider.createDeviceDefaultRules()
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
